import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface TestimonialData {
  id: string;
  name: string;
  role: string;
  image: string;
  text: string;
  rating: number;
}

@Component({
  selector: 'app-testimonial-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './testimonial-card.component.html',
  styleUrls: ['./testimonial-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestimonialCardComponent {
  @Input() testimonial!: TestimonialData;
  @Input() isActive: boolean = false;

  get stars(): number[] {
    return Array(5)
      .fill(0)
      .map((_, i) => (i < Math.floor(this.testimonial.rating) ? 1 : 0));
  }
}
